import React from 'react';

export default function Complete({ tokenData }) {
  return (
    <div style={{
      minHeight:'100vh', display:'flex', flexDirection:'column',
      alignItems:'center', justifyContent:'center',
      background:'#0a0a0a', fontFamily:'system-ui', padding:32,
      textAlign:'center',
    }}>
      <div style={{
        width:64, height:64, borderRadius:'50%',
        background:'#052e16', border:'2px solid #4ade80',
        display:'flex', alignItems:'center', justifyContent:'center',
        fontSize:28, marginBottom:24,
      }}>
        ✓
      </div>
      <div style={{ fontSize:22, fontWeight:600, color:'#fff', marginBottom:12 }}>
        Assessment Complete
      </div>
      <div style={{ fontSize:14, color:'#666', maxWidth:320, lineHeight:1.6, marginBottom:32 }}>
        Thank you. Your responses have been submitted successfully.
        Your broker will be notified and a risk engineering report will be prepared.
      </div>
      <div style={{ fontSize:12, color:'#333' }}>
        You may close this window.
      </div>
    </div>
  );
}
